import { Component,  EventEmitter,  Input, Output } from '@angular/core';
import { TagPanelData, TagType } from 'globals/store/tags.data';
import { Dictionary } from '@ngrx/entity';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { Performer } from 'globals/store/performers.data';
import { JoiResource } from 'globals/store/resources.data';
import { Sponsor } from 'globals/store/sponsors.data';
import { WorkerWithProfile } from 'globals/store/workforce.data';
import { Attendee } from 'globals/store/attendees.data';
import { CommonModule } from '@angular/common';
import { TagsComponent } from './tags.component';

@Component({
    selector: 'tag-panel-view',
    template: `
<tags 
  *ngIf="!!tagData?.attendeeTags && attendees && (!fromLogistics || tagData?.attendeeTags?.length)"
  [noTitle]="noHeaders"
  [titleIcon]="fromLogistics ? '' : 'ATTENDEES'"
  [tags]="tagData.attendeeTags"
  [title]="fromLogistics ? 'TAGGED FROM ATTENDEES' : 'Attendees'"
  [showPhoto]="true"
  [emptyText]="'No attendees tagged'"
  [readOnly]="readOnly"
  [tagText]="'+ TAG FROM ATTENDEES'"
  (remove)="removeTag.emit({ tagType: 'attendee', id: $event })"
  (open)="openTagger.emit({ event: $event, tagType: 'attendee' })"
></tags>
<tags 
  *ngIf="!!tagData?.workforceTags && workforce && (!fromLogistics || tagData?.workforceTags?.length)"
  [noTitle]="noHeaders"
  [titleIcon]="fromLogistics ? '' : 'workforce'"
  [tags]="tagData.workforceTags"
  [title]="fromLogistics ? 'TAGGED FROM WORKFORCE' : 'Workforce'"
  [showPhoto]="true"
  [emptyText]="'No workforce members tagged'"
  [readOnly]="readOnly"
  [tagText]="'+ TAG FROM WORKFORCE'"
  (remove)="removeTag.emit({ tagType: 'workforce', id: $event })"
  (open)="openTagger.emit({ event: $event, tagType: 'workforce' })"
></tags>
<tags 
  *ngIf="!!tagData?.resourceTags && resources && (!fromLogistics || tagData?.resourceTags?.length)"
  [noTitle]="noHeaders"
  [titleIcon]="fromLogistics ? '' : 'CONSTRUCTION'"
  [tags]="tagData.resourceTags"
  [title]="fromLogistics ? 'TAGGED Resources' : 'Resources'"
  [emptyText]="'No resources tagged'"
  [readOnly]="readOnly"
  [tagText]="'+ TAG RESOURCES'"
  (remove)="removeTag.emit({ tagType: 'resource', id: $event })"
  (open)="openTagger.emit({ event: $event, tagType: 'resource' })"
></tags>
<tags 
  *ngIf="!!tagData?.performerTags && performers && (!fromLogistics || tagData?.performerTags?.length)"
  [noTitle]="noHeaders"
  [titleIcon]="fromLogistics ? '' : 'performers18'"
  [tags]="tagData.performerTags"
  [title]="fromLogistics ? 'TAGGED Performers' : 'Performers'"
  [showPhoto]="true"
  [emptyText]="'No performers tagged'"
  [readOnly]="readOnly"
  [tagText]="'+ TAG PERFORMERS'"
  (remove)="removeTag.emit({ tagType: 'performer', id: $event })"
  (open)="openTagger.emit({ event: $event, tagType: 'performer' })"
></tags>
<tags 
  *ngIf="!!tagData?.sponsorTags && sponsors && (!fromLogistics || tagData?.sponsorTags?.length)"
  [noTitle]="noHeaders"
  [titleIcon]="fromLogistics ? '' : 'sponsor18'"
  [tags]="tagData.sponsorTags"
  [title]="fromLogistics ? 'TAGGED Sponsors' : 'Sponsors'"
  [emptyText]="'No sponsors tagged'"
  [readOnly]="readOnly"
  [tagText]="'+ TAG SPONSORS'"
  (remove)="removeTag.emit({ tagType: 'sponsor', id: $event })"
  (open)="openTagger.emit({ event: $event, tagType: 'sponsor' })"
></tags>
<tags 
  *ngIf="!!tagData?.exhibitorTags && exhibitors && (!fromLogistics || tagData?.exhibitorTags?.length)"
  [noTitle]="noHeaders"
  [titleIcon]="fromLogistics ? '' : 'exhibitors_18'"
  [tags]="tagData.exhibitorTags"
  [title]="fromLogistics ? 'TAGGED Exhibitors' : 'Exhibitors'"
  [emptyText]="'No exhibitors tagged'"
  [readOnly]="readOnly"
  [tagText]="'+ TAG EXHIBITORS'"
  (remove)="removeTag.emit({ tagType: 'exhibitor', id: $event })"
  (open)="openTagger.emit({ event: $event, tagType: 'exhibitor' })"
></tags>
`,
    styleUrls: ['./tags.scss'],
    standalone: true,
    imports: [CommonModule, TagsComponent],
})
export class TagPanelViewComponent {
  @Input() tagData: TagPanelData
  @Input() readOnly = false
  @Input() noHeaders = false
  @Input() fromLogistics: boolean = false
  @Input() performers: Dictionary<Performer>
  @Input() sponsors: Dictionary<Sponsor>
  @Input() exhibitors: Dictionary<Exhibitor>
  @Input() resources: Dictionary<JoiResource>
  @Input() workforce: WorkerWithProfile[]
  @Input() attendees: Dictionary<Attendee>

  @Output() removeTag: EventEmitter<{ tagType: TagType, id: string }> = new EventEmitter()
  @Output() setTags: EventEmitter<{ tagType: TagType, ids: string[] }> = new EventEmitter()
  @Output() openTagger: EventEmitter<{ event: any, tagType: TagType }> = new EventEmitter()
}

